import { cn } from '@/core/lib/utils/cn'

export function AttributeFilter({
  label,
  values,
  selectedValues,
  onSelect,
}: {
  label: string
  values: { id: number | string; name: string }[]
  selectedValues?: (number | string)[]
  onSelect: (value: number | string) => void
}) {
  return (
    <div>
      <h3 className='my-2 text-lg font-semibold'>{label}</h3>
      <div className='flex flex-wrap gap-2'>
        {values.map(value => {
          const isSelected = selectedValues?.some(
            v => v?.toString() == value.id.toString(),
          )
          return (
            <button
              key={value.id}
              onClick={() => onSelect(value.id)}
              className={cn(
                'flex cursor-pointer items-center gap-2 rounded-xs px-3 py-1 text-sm ring transition',
                isSelected
                  ? 'ring-mountain-bluebird text-mountain-bluebird ring-2'
                  : 'ring-dim-gray text-dim-gray',
              )}
            >
              {value.name}
            </button>
          )
        })}
      </div>
    </div>
  )
}
